import { useRoute } from '@huaca/ui';
import { Dashboard } from './dashboard/Dashboard';
import { TemplateBuilder } from './builder/TemplateBuilder';
import { SnapshotEditor } from './builder/SnapshotEditor';
import { TemplateList } from './templates/TemplateList';

/**
 * Client-side routing for the authenticated pro app (the hand-rolled `useRoute` has no `:id`, so we
 * parse the path ourselves). Any path that isn't one of the platform's reserved ones lands here.
 *   /templates              → manage templates
 *   /templates/new          → build a new template
 *   /templates/:id          → edit an existing template
 *   /instances/:id/snapshot → edit THIS onboarding's own form
 *   /instances/:id          → the dashboard with that onboarding pre-selected (return target)
 *   (anything else)         → the dashboard (split-screen clients + detail)
 */
export function Product() {
  const { path } = useRoute();
  const parts = path.split('/').filter(Boolean);

  if (parts[0] === 'templates') {
    const sub = parts[1];
    if (!sub) return <TemplateList />;
    return <TemplateBuilder templateId={sub === 'new' ? null : sub} />;
  }
  if (parts[0] === 'instances' && parts[1]) {
    if (parts[2] === 'snapshot') return <SnapshotEditor instanceId={parts[1]} />;
    return <Dashboard initialSelectedId={parts[1]} />;
  }
  return <Dashboard />;
}
